module.exports = __webpack_public_path__ + "static/media/ios-api.89eec357.md";